const STORAGE_KEY = 'pehr:upsell-dismissed';

function readDismissed() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
}

function writeDismissed(ids) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch (error) {
    /* storage unavailable, dismissal is not remembered */
  }
}

class UpsellProductsComponent extends HTMLElement {
  connectedCallback() {
    const dismissed = readDismissed();

    this.querySelectorAll('[data-upsell-id]').forEach((card) => {
      if (dismissed.includes(card.dataset.upsellId)) {
        card.remove();
      }
    });

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-upsell-dismiss]');
      if (!button) return;

      const card = button.closest('[data-upsell-id]');
      if (!card) return;

      const ids = readDismissed();
      if (!ids.includes(card.dataset.upsellId)) {
        ids.push(card.dataset.upsellId);
        writeDismissed(ids);
      }

      card.remove();
    });
  }
}

if (!customElements.get('upsell-products-component')) {
  customElements.define('upsell-products-component', UpsellProductsComponent);
}
